import { AgentSessionLabel } from '../../../api/agent-miner-client/agent-miner-client.type';
import {
  blueDarkest,
  blueLight,
  blueLightest,
  inkDark,
  inkDarkest,
  inkLight,
  pinkDarkest,
  pinkLight,
  pinkLightest,
  primaryDarkest,
  primaryLight,
  primaryLightest,
  purpleDarkest,
  purpleLight,
  purpleLightest,
  redDarkest,
  redLight,
  redLightest,
  secondaryDarkest,
  secondaryLight,
  secondaryLightest,
  skyBase,
  skyDark,
  skyLight,
  skyLighter,
  skyLightest,
} from '../../../styles/design-tokens';

interface CategoryColors {
  text: string;
  border: string;
  background: string;
}

const UNCLASSIFIED_COLORS: CategoryColors = {
  text: inkLight,
  border: skyBase,
  background: skyLightest,
};

const CATEGORY_COLORS: Record<AgentSessionLabel, CategoryColors> = {
  [AgentSessionLabel.BugFix]: { text: redDarkest, border: redLight, background: redLightest },
  [AgentSessionLabel.FeatureBuild]: { text: primaryDarkest, border: primaryLight, background: primaryLightest },
  [AgentSessionLabel.Refactor]: { text: secondaryDarkest, border: secondaryLight, background: secondaryLightest },
  [AgentSessionLabel.TestingCoverage]: { text: purpleDarkest, border: purpleLight, background: purpleLightest },
  [AgentSessionLabel.Investigation]: { text: inkDarkest, border: skyDark, background: skyLighter },
  [AgentSessionLabel.Documentation]: { text: blueDarkest, border: blueLight, background: blueLightest },
  [AgentSessionLabel.Devops]: { text: pinkDarkest, border: pinkLight, background: pinkLightest },
  [AgentSessionLabel.CodeReview]: { text: inkDark, border: skyLight, background: skyLightest },
  [AgentSessionLabel.Unclassified]: UNCLASSIFIED_COLORS,
};

export { CATEGORY_COLORS, UNCLASSIFIED_COLORS };
export type { CategoryColors };
